/** Curated emoji set for the ":" picker. Keys are the search names. */
export const EMOJI: { name: string; char: string }[] = [
  { name: 'smile', char: '😄' },
  { name: 'grin', char: '😁' },
  { name: 'joy', char: '😂' },
  { name: 'rofl', char: '🤣' },
  { name: 'slight_smile', char: '🙂' },
  { name: 'wink', char: '😉' },
  { name: 'blush', char: '😊' },
  { name: 'heart_eyes', char: '😍' },
  { name: 'kiss', char: '😘' },
  { name: 'thinking', char: '🤔' },
  { name: 'neutral', char: '😐' },
  { name: 'smirk', char: '😏' },
  { name: 'unamused', char: '😒' },
  { name: 'roll_eyes', char: '🙄' },
  { name: 'grimacing', char: '😬' },
  { name: 'relieved', char: '😌' },
  { name: 'pensive', char: '😔' },
  { name: 'sleepy', char: '😴' },
  { name: 'mask', char: '😷' },
  { name: 'sunglasses', char: '😎' },
  { name: 'nerd', char: '🤓' },
  { name: 'confused', char: '😕' },
  { name: 'worried', char: '😟' },
  { name: 'frown', char: '🙁' },
  { name: 'open_mouth', char: '😮' },
  { name: 'astonished', char: '😲' },
  { name: 'scream', char: '😱' },
  { name: 'cry', char: '😢' },
  { name: 'sob', char: '😭' },
  { name: 'sweat', char: '😓' },
  { name: 'angry', char: '😠' },
  { name: 'rage', char: '😡' },
  { name: 'exploding_head', char: '🤯' },
  { name: 'party', char: '🥳' },
  { name: 'cowboy', char: '🤠' },
  { name: 'clown', char: '🤡' },
  { name: 'ghost', char: '👻' },
  { name: 'alien', char: '👽' },
  { name: 'robot', char: '🤖' },
  { name: 'poop', char: '💩' },
  { name: 'skull', char: '💀' },
  { name: 'heart', char: '❤️' },
  { name: 'broken_heart', char: '💔' },
  { name: 'sparkling_heart', char: '💖' },
  { name: 'fire', char: '🔥' },
  { name: 'sparkles', char: '✨' },
  { name: 'star', char: '⭐' },
  { name: 'boom', char: '💥' },
  { name: 'zap', char: '⚡' },
  { name: 'rainbow', char: '🌈' },
  { name: 'sun', char: '☀️' },
  { name: 'cloud', char: '☁️' },
  { name: 'rain', char: '🌧️' },
  { name: 'snowflake', char: '❄️' },
  { name: 'thumbsup', char: '👍' },
  { name: 'thumbsdown', char: '👎' },
  { name: 'ok_hand', char: '👌' },
  { name: 'clap', char: '👏' },
  { name: 'wave', char: '👋' },
  { name: 'raised_hands', char: '🙌' },
  { name: 'pray', char: '🙏' },
  { name: 'muscle', char: '💪' },
  { name: 'point_right', char: '👉' },
  { name: 'point_left', char: '👈' },
  { name: 'point_up', char: '☝️' },
  { name: 'point_down', char: '👇' },
  { name: 'handshake', char: '🤝' },
  { name: 'crossed_fingers', char: '🤞' },
  { name: 'victory', char: '✌️' },
  { name: 'eyes', char: '👀' },
  { name: 'brain', char: '🧠' },
  { name: 'tada', char: '🎉' },
  { name: 'confetti', char: '🎊' },
  { name: 'balloon', char: '🎈' },
  { name: 'gift', char: '🎁' },
  { name: 'trophy', char: '🏆' },
  { name: 'medal', char: '🥇' },
  { name: 'rocket', char: '🚀' },
  { name: 'airplane', char: '✈️' },
  { name: 'car', char: '🚗' },
  { name: 'bike', char: '🚲' },
  { name: 'hourglass', char: '⏳' },
  { name: 'clock', char: '🕐' },
  { name: 'alarm', char: '⏰' },
  { name: 'calendar', char: '📅' },
  { name: 'pushpin', char: '📌' },
  { name: 'paperclip', char: '📎' },
  { name: 'scissors', char: '✂️' },
  { name: 'pencil', char: '✏️' },
  { name: 'memo', char: '📝' },
  { name: 'book', char: '📖' },
  { name: 'books', char: '📚' },
  { name: 'bulb', char: '💡' },
  { name: 'mag', char: '🔍' },
  { name: 'lock', char: '🔒' },
  { name: 'unlock', char: '🔓' },
  { name: 'key', char: '🔑' },
  { name: 'hammer', char: '🔨' },
  { name: 'wrench', char: '🔧' },
  { name: 'gear', char: '⚙️' },
  { name: 'link', char: '🔗' },
  { name: 'bell', char: '🔔' },
  { name: 'mega', char: '📣' },
  { name: 'email', char: '📧' },
  { name: 'phone', char: '📱' },
  { name: 'computer', char: '💻' },
  { name: 'bug', char: '🐛' },
  { name: 'check', char: '✅' },
  { name: 'x', char: '❌' },
  { name: 'warning', char: '⚠️' },
  { name: 'question', char: '❓' },
  { name: 'exclamation', char: '❗' },
  { name: 'hundred', char: '💯' },
  { name: 'money', char: '💰' },
  { name: 'chart_up', char: '📈' },
  { name: 'chart_down', char: '📉' },
  { name: 'coffee', char: '☕' },
  { name: 'beer', char: '🍺' },
  { name: 'pizza', char: '🍕' },
  { name: 'burger', char: '🍔' },
  { name: 'cake', char: '🎂' },
  { name: 'apple', char: '🍎' },
  { name: 'banana', char: '🍌' },
  { name: 'dog', char: '🐶' },
  { name: 'cat', char: '🐱' },
  { name: 'unicorn', char: '🦄' },
  { name: 'bee', char: '🐝' },
  { name: 'turtle', char: '🐢' },
  { name: 'penguin', char: '🐧' },
  { name: 'flower', char: '🌸' },
  { name: 'tree', char: '🌳' },
  { name: 'earth', char: '🌍' },
  { name: 'moon', char: '🌙' },
  { name: 'wave_water', char: '🌊' },
];
